export default function (value) {
  if (!value) return ''

  let trimmedValue = value.replace(/\s/g, '')
  let formattedValue = [...trimmedValue]

  if (trimmedValue.slice(0, 4) === '0800' && trimmedValue.length === 10) {
    return trimmedValue.substr(0, 1) + ' ' + trimmedValue.substr(1).match(/.{1,3}/g).join(' ')
  }

  if (trimmedValue.slice(0, 3) === '380') {
    formattedValue.splice(0, 3)
  }

  if (value[0] === '0') {
    formattedValue.splice(0, 1)
  }
  formattedValue.splice(2, 0, ')')
  formattedValue.splice(3, 0, ' ')
  formattedValue.splice(7, 0, ' ')
  formattedValue.splice(10, 0, ' ')

  return '+38 (0' + formattedValue.join('')
  // return value[0] === '0' ? '+38 (0' + formattedValue.join('') : '(0' + formattedValue.join('')
}
